module.exports = __webpack_public_path__ + "img/7.98d2615c.jpg";